module.exports = __webpack_public_path__ + "media/stylesheets/images/rulers-059d18efa4b6f290306f5e3f12ce42d8.svg";